import { Spin } from "antd";

/**
 * Loading fallback component for Suspense
 */
export const LoadingFallback = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-screen bg-gray-50">
      <Spin size="large" />
    </div>
  );
};
